<template>
    <ReserveComplete />
</template>

<script>
import ReserveComplete from "@/components/ReserveComplete.vue";


export default {
    name: 'ReserveCompleteView',
    components: {
        ReserveComplete
    }
}
</script>